/* eslint-disable react-refresh/only-export-components */
import { createContext, useContext } from 'react';

const PreviewContext = createContext();

export const PreviewContextProvider = props => {
  return (
    <PreviewContext.Provider value={{}}>
      {props.children}
    </PreviewContext.Provider>
  );
};

export const usePreviewContext = () => useContext(PreviewContext);
